import {Injectable} from '@angular/core';
import {interval, Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({providedIn: 'root'})
export class CountdownService {
	getCountdown(targetTime: moment.Moment): Observable<number> {
		return interval(1000).pipe(
			startWith(0),
			map(() => targetTime.diff(moment(), 'seconds'))
		);
	}
}
